import { makeStyles } from '@material-ui/core';
import { CartPiece } from 'components/WidgetInflationCart/WidgetInflationCart';
import React from 'react';

interface FoodCardProps {
    card: CartPiece;
}

const useStyles = makeStyles((theme) => ({
    foodCard: {
        backgroundColor: '#A53470',
        width: '298px',
        height: '363px',
        flexShrink: 0,
        borderRadius: '10px',
        padding: '20px',
        [theme.breakpoints.down('sm')]: {
            height: '300px',
        },
    },
    svg: {
        width: '66px',
        height: '72px',
        flexShrink: 0,
        fill: theme.colors.white,
    },
    h3: {
        color: theme.colors.white,
        textAlign: 'center',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal',
        width: '220px',
        height: '35px',
        flexShrink: 0,
        margin: '0px auto 18px',
    },
    li: {
        color: theme.colors.white,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        // lineHeight: 'normal',
        lineHeight: '30px' /* 178.571% */,
    },
    svgIcon: {
        textAlign: 'center',
    },
    desc: {
        display: 'flex',
        lineHeight: '17px',
    },
}));

const Food = ({ card }: FoodCardProps) => {
    const classes = useStyles();
    return (
        <div className={classes.foodCard}>
            <div className={classes.svgIcon}>
                <svg
                    className={classes.svg}
                    xmlns="http://www.w3.org/2000/svg"
                    width="66"
                    height="72"
                    viewBox="0 0 66 72"
                    fill="none"
                    data-card={card.card}
                >
                    <path
                        d="M64.7049 59.5862H62.2143V47.1724H64.7049C65.4023 47.1724 65.9502 46.6262 65.9502 45.931C65.9502 39.7738 60.9192 34.7586 54.7426 34.7586H50.3841L51.3804 11.2221C51.3804 10.8745 51.2808 10.5517 51.0317 10.3034C50.8075 10.0552 50.4838 9.93103 50.1351 9.93103H34.7434L35.0921 2.48276H49.4626C50.16 2.48276 50.7079 1.93655 50.7079 1.24138C50.7079 0.546207 50.16 0 49.4626 0H33.9215C33.2491 0 32.7011 0.521379 32.6762 1.19172L32.2528 9.93103H15.7902C15.4415 9.93103 15.1177 10.08 14.8936 10.3034C14.6694 10.5517 14.5449 10.8745 14.5449 11.2221L15.4415 33.269C12.6521 32.0028 9.43924 32.3503 9.2649 32.3752C8.69207 32.4497 8.24377 32.8965 8.16906 33.4676C8.14415 33.691 7.54641 38.8055 10.5102 41.7352C10.6098 41.8345 10.7094 41.9338 10.834 42.0331C4.70717 42.9269 0 45.6083 0 53.3793C0 63.6579 8.3683 72 18.6792 72C22.4151 72 26.0513 70.8828 29.1396 68.7972C29.9864 70.6841 31.9041 71.9752 34.0958 71.9752H60.5457C63.5592 71.9752 66 69.5421 66 66.5379V60.8028C66 60.1076 65.4521 59.5614 64.7547 59.5614L64.7049 59.5862ZM34.8181 59.5862V54.6207H59.7238V59.5862H34.8181ZM59.7238 52.1379H34.8181V47.1724H59.7238V52.1379ZM63.36 44.6897H31.157C31.7547 40.4938 35.3909 37.2414 39.7743 37.2414H54.7177C59.1011 37.2414 62.7374 40.4938 63.3351 44.6897H63.36ZM39.7992 34.7586C34.7932 34.7586 30.5592 38.0359 29.1147 42.5545C26.3751 41.8097 23.1374 41.6359 19.9245 41.5862C19.9245 39.9476 19.6257 37.2166 17.9819 35.2055L17.4589 22.3448H48.4166L47.8936 34.7586H39.7992ZM48.84 12.4138L48.5162 19.8621H34.2453L34.594 12.4138H48.8151H48.84ZM32.1283 12.4138L31.7796 19.8621H17.3842L17.0853 12.4138H32.1283ZM12.2536 39.9724C10.8091 38.5324 10.5849 36.149 10.5849 34.8083C11.9547 34.8083 14.3457 35.0566 15.7653 36.4717C17.1849 37.8869 17.434 40.2207 17.434 41.5862C17.1351 41.5862 16.8611 41.5862 16.5623 41.5862C15.1925 41.4869 13.3992 41.1145 12.2287 39.9476L12.2536 39.9724ZM29.837 59.5862C29.1396 59.5862 28.5917 60.1324 28.5917 60.8276V66.091C25.7525 68.3007 22.2408 69.5172 18.6294 69.5172C9.71321 69.5172 2.44075 62.2676 2.44075 53.3793C2.44075 45.509 7.89509 44.069 18.6294 44.069C22.166 44.069 25.7774 44.1931 28.6415 44.9876C28.6166 45.3103 28.5917 45.6083 28.5917 45.931C28.5917 46.6262 29.1396 47.1724 29.837 47.1724H32.3275V59.5862H29.837ZM63.4596 66.5628C63.4596 68.1765 62.1396 69.5172 60.4958 69.5172H34.046C32.4272 69.5172 31.0823 68.2014 31.0823 66.5628V62.069H63.4596V66.5628Z"
                        fill="white"
                    />
                </svg>
            </div>
            <hr />
            <h3 className={classes.h3}>{card.header}</h3>
            <ul>
                {card.list.map((item) => (
                    <li
                        className={classes.li}
                        key={`${card.card}-${Math.random()}`}
                    >
                        <span className={classes.desc}>{item.desc}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Food;
